import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { appRoutePaths, getFullAppRoutePath } from '_lib/featureComponents/Nav/nav.types';
import { useAuthRoles } from '_lib/hooks/useAuthRoles';

function handleAppBeforeUnload(event: BeforeUnloadEvent) {
  event.preventDefault();
  (event || window.event).returnValue = 'You may have unsaved changes, would you still like to continue?';
  return true;
}

export const useCallLogNavigate = () => {
  const navigate = useNavigate();

  const authRoles = useAuthRoles();

  useEffect(() => {
    if (authRoles.isAccountUser || authRoles.isAccountAdmin) {
      window.addEventListener('beforeunload', handleAppBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleAppBeforeUnload);
      };
    }
    return () => {};
  }, [authRoles.isAccountAdmin, authRoles.isAccountUser]);

  const navigateToCallLog = () => {
    return navigate(getFullAppRoutePath(appRoutePaths.CallLog), { replace: true });
  };

  return { navigateToCallLog };
};
